import { useContext, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { validateURL } from 'services/pages';
import { ContextWrapper } from 'contexts/wrapper.context';
import { getSllrLink } from 'utils/sllr-store';
import { CUSTOM_DOMAINS_STATUSES } from 'constants/sllr';

import BRFormInputs from 'components/BRFormInputs/BRFormInputs';
import BRButton from 'components/BRButton/BRButton';
import { notify } from 'components/Notify/Notify';

import { ReactComponent as CheckIcon } from 'assets/bosta-icons/CheckIcon.svg';

import './URLField.less';

const URLField = ({ formRef, urlName, fetchPageDetailsURL }) => {
  const { formatMessage } = useIntl();
  const { businessInfo } = useContext(ContextWrapper);

  const [isValidatingURL, setIsValidatingURL] = useState(false);
  const [isValidURL, setIsValidURL] = useState(false);
  const [showURLErrorMsg, setShowURLErrorMsg] = useState(false);

  const hasCustomDomain = () =>
    businessInfo?.storeInfo?.domainStatus === CUSTOM_DOMAINS_STATUSES.CONNECTED;

  const handleURLValidation = async () => {
    setIsValidatingURL(true);

    const payload = {
      url: formRef.current.getFieldValue('url')
    };

    try {
      const { isValidUrl } = await validateURL(payload);
      setShowURLErrorMsg(!isValidUrl);
      setIsValidURL(isValidUrl);
    } catch (error) {
      notify({ msg: error.message, error });
      setIsValidURL(false);
    }

    setIsValidatingURL(false);
  };

  useEffect(() => {
    if (isValidURL) {
      setIsValidURL(false);
    }
  }, [urlName]);

  return (
    <BRFormInputs
      className="br-url-field"
      name="url"
      inputTitle={formatMessage({
        id: 'pages.create_edit_page.form.url_field.label'
      })}
      prefix={
        businessInfo?.storeInfo &&
        (hasCustomDomain()
          ? getSllrLink(businessInfo)
          : `${businessInfo.storeInfo.storeLink}/`)
      }
      placeholder={formatMessage({
        id: 'pages.create_edit_page.form.url_field.placeholder'
      })}
      rules={[
        {
          required: true,
          whitespace: true,
          message: formatMessage({
            id: 'pages.create_edit_page.form.url_field.error_msgs.required'
          })
        }
      ]}
      validateStatus={showURLErrorMsg && 'error'}
      help={
        showURLErrorMsg
          ? formatMessage({
              id: 'pages.create_edit_page.form.url_field.error_msgs.repeated'
            })
          : businessInfo?.storeInfo && (
              <>
                {`${getSllrLink(businessInfo)}${hasCustomDomain() ? '' : '/'}`}
                <span className="br-url-field__hint__url-name">
                  {urlName ||
                    formatMessage({
                      id: 'pages.create_edit_page.form.url_field.placeholder'
                    })}
                </span>
              </>
            )
      }
      disabled={isValidatingURL}
      addonAfter={
        <BRButton
          label={formatMessage({ id: 'common.validate' })}
          type="primary"
          className="button-md"
          loading={isValidatingURL}
          onClick={handleURLValidation}
          disabled={!urlName || isValidURL || urlName === fetchPageDetailsURL}
        />
      }
      suffix={isValidURL && <CheckIcon />}
    />
  );
};

export default URLField;
